
import React from 'react'
import EmptyBoxIcon from '../../ui/Icons/EmptyBoxIcon'
import Title from '../../Core/Title'
import { theme } from '../../Theme'
import { useIntl } from '@jetshop/intl'
import { styled } from 'linaria/react'
const NoProductsFoundContainer = styled.div`
   .no-products-found-title {
      color: ${theme.colors.darkerGrey};
   }
`

const NoProductsFound = ({ title }) => {
   const t = useIntl()
   
   return (
      <NoProductsFoundContainer className="d-flex flex-column align-items-center justify-content-center gap-2 mt-3 mt-lg-none">
         <EmptyBoxIcon 
            width={100} 
            height={100} 
            strokeWidth={8} 
            color={theme.colors.darkerGrey}
         />
         <Title 
            className="no-products-found-title"
            fontFamily={'Industry'} 
            weight={700} 
            size={'1.25rem'} 
         >
            {title || t('no products found')}
         </Title>
      </NoProductsFoundContainer>
   )
}

export default NoProductsFound